var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconVolume(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_18005_37058)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.3856 1.50403C16.6026 1.28707 16.9544 1.28707 17.1713 1.50403L18.3498 2.68254C18.5668 2.8995 18.5668 3.25125 18.3498 3.46821L17.2864 4.53167L15.3222 2.56749L16.3856 1.50403Z",
    fill: "#002CFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5365 3.35316L16.5007 5.31735L13.3556 8.46244C12.9569 8.86116 12.4215 9.0934 11.8579 9.11209L11.0001 9.14055C10.8396 9.14588 10.708 9.01428 10.7133 8.85371L10.7418 7.99592C10.7605 7.43235 10.9927 6.89697 11.3914 6.49825L14.5365 3.35316Z",
    fill: "#002CFB"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.63953 4.44452C5.95109 4.44452 5.36653 4.94886 5.26564 5.62987L4.6182 10.0001H7.37741C7.97523 10.0001 8.50598 10.3826 8.69503 10.9498L8.87071 11.4768C8.90852 11.5902 9.01467 11.6667 9.13423 11.6667H10.8659C10.9854 11.6667 11.0916 11.5902 11.1294 11.4768L11.3051 10.9498C11.4941 10.3826 12.0249 10.0001 12.6227 10.0001H15.3819L15.2868 9.35831C15.2194 8.90305 15.5338 8.4793 15.989 8.41185C16.4443 8.34441 16.8681 8.6588 16.9355 9.11407L17.1173 10.3413C17.1872 10.813 17.2223 11.2892 17.2223 11.7661V13.6112C17.2223 15.6056 15.6055 17.2223 13.6112 17.2223H6.38894C4.39458 17.2223 2.77783 15.6056 2.77783 13.6112V11.7661C2.77783 11.2892 2.81292 10.813 2.8828 10.3413L3.61697 5.38562C3.83893 3.88739 5.12495 2.77786 6.63953 2.77786H10.8334C11.2936 2.77786 11.6667 3.15095 11.6667 3.61119C11.6667 4.07143 11.2936 4.44452 10.8334 4.44452H6.63953ZM4.4445 11.7661C4.4445 11.7329 4.4447 11.6998 4.44511 11.6667H7.1772L7.28957 12.0039C7.55424 12.7979 8.29728 13.3334 9.13423 13.3334H10.8659C11.7028 13.3334 12.4459 12.7979 12.7105 12.0039L12.8229 11.6667H15.555C15.5554 11.6998 15.5556 11.7329 15.5556 11.7661V13.6112C15.5556 14.6851 14.6851 15.5556 13.6112 15.5556H6.38894C5.31506 15.5556 4.4445 14.6851 4.4445 13.6112V11.7661Z",
    fill: "#002CFB"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_18005_37058"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconVolume);
export default __webpack_public_path__ + "static/media/iconVolume.fbd88864d41082286a00a1ef1f3d07e1.svg";
export { ForwardRef as ReactComponent };